<div class="shadow-preview">
    <label class="shadow-preview-title" cvLocalizedText langSection="Challenges_Create" langKey="Challenge_Preview">
        Challenge preview
    </label>
    <div class="progress-container" #progressContainer (mouseover)="toggleTooltip(true)"
        (mouseleave)="toggleTooltip(false)">
        <div class="progress" role="progressbar" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100">
            <div class="progress-bar overflow-visible text-dark" style="width: 100%">
                <span class="difficulty">{{ hp }} / {{ hp }}</span>
            </div>
        </div>

        <!-- Tooltip -->
        <span [ngClass]="{
            'health-points-tooltip': true,
            'display-tooltip': showTooltip
          }" cvLocalizedText langSection="Challenges_Details" langKey="Shadow_Health_Points">
            Shadow Health Points
        </span>
    </div>

    <div class="date-container">
        <label class="date-range">
            {{startDateRange}} - {{endDateRange}}
        </label>
    </div>
    <div class="card">
        <div class="card-header">
            <div class="activity">
                <img src="../App_Themes/clearview-default/images/challenges/shadowboxing/shadow_boxing.svg"
                    alt="Shadow Boxing Icon" width="21" height="21" class="icon-16">
                <span class="metric-name">{{ metricName }}</span>
            </div>
            <div class="end-date">
                <span cvLocalizedText langSection="Challenges_Create" langKey="Challenge_End_Date">End Date: </span>
                {{ endDate }}
            </div>
        </div>
        <div class="card-body">
            <div class="score">
                <label class="today-score-text" cvLocalizedText langSection="Challenges_Create"
                    langKey="Shadow_Boxing_Todays_Score">Today's score</label>
                <label class="today-score">--</label>
            </div>
            <div class="goal">
                <label class="goal-title" cvLocalizedText langSection="Challenges_Create"
                    langKey="Daily_Goal_Card">Daily Goal</label>
                <label class="today-score">{{ dailyGoal ?? '---' }}</label>

            </div>
            <div class="reward">
                <label class="reward-title" cvLocalizedText langSection="Challenges_Create"
                    langKey="Reward">Reward</label>
                <div class="reward-content">
                    <img src="../App_Themes/clearview-default/images/challenges/shadowboxing/Gems.svg"
                        alt="Shadow Boxing Icon" width="12" height="9" class="icon-16">
                    <span class="today-score">{{ gems }}</span>
                </div>
            </div>
        </div>
        <label cvLocalizedText langSection="Challenges_Create" langKey="Punch_Available" class="punch-available">Punch
            Available!
        </label>
    </div>
</div>